<div class="neuer-kontakt-dialog">
    <h2 mat-dialog-title>
        <mat-icon>{{ dialogModus === "suche" ? "search" : "add_business" }}</mat-icon>
        <span>{{ dialogModus === "suche" ? "Betrieb suchen" : "Neuen Kontakt erstellen" }}</span>
    </h2>

    <mat-dialog-content>
        <!-- Suchmodus -->
        <div *ngIf="dialogModus === 'suche'" class="suche-modus">
            <div class="dialog-info">
                <p>Geben Sie eine VVVO-Nummer ein, um nach bestehenden Betrieben zu suchen:</p>
            </div>

            <form [formGroup]="neuerKontaktForm" class="neuer-kontakt-form">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>VVVO-Nummer *</mat-label>
                        <input
                            matInput
                            formControlName="vvvo"
                            placeholder="15-stellige VVVO-Nummer"
                            maxlength="15"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            (input)="onVvvoInput($event)"
                            (keypress)="onKeyPress($event)"
                            (paste)="onPaste($event)"
                        />
                        <mat-error *ngIf="neuerKontaktForm.get('vvvo')?.hasError('required')">
                            VVVO-Nummer ist erforderlich
                        </mat-error>
                        <mat-error *ngIf="neuerKontaktForm.get('vvvo')?.hasError('pattern')">
                            VVVO-Nummer muss genau 15 Zahlen enthalten
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>

            <!-- Loading State für Suche -->
            <div *ngIf="ladeBetriebssuche" class="loading-container">
                <mat-spinner diameter="32"></mat-spinner>
                <p>Suche nach Betrieben...</p>
            </div>

            <!-- Gefundene Betriebe -->
            <div *ngIf="!ladeBetriebssuche && gefundeneBetriebe.length > 0" class="gefundene-betriebe">
                <h3>Gefundene Betriebe:</h3>
                <div class="betriebe-liste">
                    <kiene-betriebskontakt-card
                        *ngFor="let betrieb of gefundeneBetriebe"
                        [kontakt]="betrieb"
                        [config]="{
                            showActions: true,
                            showMenu: false,
                            showFavorit: false,
                            showBadge: true,
                            compact: true,
                            selectedMode: false,
                            showHinzufuegen: true,
                            istKontaktBereitsVorhanden: betrieb.bereits_kontakt > 0,
                            ladeHinzufuegen: ladeHinzufuegen
                        }"
                        (hinzufuegen)="waehleBetriebAus($event)"
                    >
                    </kiene-betriebskontakt-card>
                </div>
            </div>

            <!-- Keine Betriebe gefunden -->
            <div
                *ngIf="
                    !ladeBetriebssuche &&
                    gefundeneBetriebe.length === 0 &&
                    neuerKontaktForm.get('vvvo')?.value?.length === 15
                "
                class="keine-betriebe"
            >
                <mat-icon>info</mat-icon>
                <h3>Keine Betriebe gefunden</h3>
                <p
                    >Es wurden keine Betriebe mit der VVVO-Nummer
                    <strong>{{ neuerKontaktForm.get("vvvo")?.value }}</strong> gefunden.</p
                >
                <p>Möchten Sie einen neuen Kontakt erstellen?</p>
                <button mat-raised-button color="primary" (click)="erstelleNeuenBetrieb()">
                    <mat-icon>add</mat-icon>
                    Neuen Kontakt erstellen
                </button>
            </div>
        </div>

        <!-- Erstellungsmodus -->
        <div *ngIf="dialogModus === 'erstellen'" class="erstellen-modus">
            <div class="dialog-info">
                <p
                    >Erstellen Sie einen neuen Betriebskontakt mit der VVVO-Nummer:
                    <strong>{{ neuerKontaktForm.get("vvvo")?.value }}</strong></p
                >
                <button mat-button (click)="zurueckZurSuche()" class="zurueck-button">
                    <mat-icon>arrow_back</mat-icon>
                    Zurück zur Suche
                </button>
            </div>

            <form [formGroup]="neuerKontaktForm" class="neuer-kontakt-form">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>VVVO-Nummer *</mat-label>
                        <input
                            matInput
                            formControlName="vvvo"
                            placeholder="15-stellige VVVO-Nummer"
                            maxlength="15"
                            inputmode="numeric"
                            (input)="onVvvoInput($event)"
                            readonly
                        />
                        <mat-error *ngIf="neuerKontaktForm.get('vvvo')?.hasError('required')">
                            VVVO-Nummer ist erforderlich
                        </mat-error>
                        <mat-error *ngIf="neuerKontaktForm.get('vvvo')?.hasError('pattern')">
                            VVVO-Nummer muss genau 15 Zahlen enthalten
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Betriebsname *</mat-label>
                        <input matInput formControlName="bezeichnung" placeholder="Name des Betriebs" />
                        <mat-error *ngIf="neuerKontaktForm.get('bezeichnung')?.hasError('required')">
                            Betriebsname ist erforderlich
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Zusatz</mat-label>
                        <input matInput formControlName="zusatz" placeholder="Zusatz zum Betriebsnamen" />
                    </mat-form-field>
                </div>

                <!-- Händler-Flag -->
                <div class="form-row">
                    <mat-checkbox formControlName="ist_haendler" class="haendler-checkbox">
                        <span class="checkbox-label">
                            <mat-icon>store</mat-icon>
                            Ist Händler
                        </span>
                    </mat-checkbox>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Straße</mat-label>
                        <input matInput formControlName="strasse" placeholder="Straße und Hausnummer" />
                    </mat-form-field>
                </div>

                <div class="form-row two-columns">
                    <mat-form-field appearance="outline">
                        <mat-label>PLZ</mat-label>
                        <input matInput formControlName="plz" placeholder="PLZ" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Ort</mat-label>
                        <input matInput formControlName="ort" placeholder="Ort" />
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>E-Mail</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="E-Mail-Adresse" />
                    </mat-form-field>
                </div>

                <div class="form-row two-columns">
                    <mat-form-field appearance="outline">
                        <mat-label>Telefon</mat-label>
                        <input matInput formControlName="telefon_1" placeholder="Telefonnummer" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Mobil</mat-label>
                        <input matInput formControlName="mobil_1" placeholder="Mobilnummer" />
                    </mat-form-field>
                </div>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="abbrechen()" [disabled]="ladeErstelleKontakt || ladeBetriebssuche">
            Abbrechen
        </button>

        <!-- Aktionen für Erstellungsmodus -->
        <div *ngIf="dialogModus === 'erstellen'">
            <button
                mat-raised-button
                color="accent"
                (click)="erstelleNeuenKontakt()"
                [disabled]="ladeErstelleKontakt || !neuerKontaktForm.valid"
            >
                <mat-spinner *ngIf="ladeErstelleKontakt" diameter="16"></mat-spinner>
                <mat-icon *ngIf="!ladeErstelleKontakt">add</mat-icon>
                {{ ladeErstelleKontakt ? "Erstelle..." : "Kontakt erstellen" }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
